import React, { useRef, useState } from "react";
import { Loader2, ScanLine } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

const merge = (c, o) => {
  const rep = c.representant || { signataire_is_rep: true };
  const pick = (k) => o[k] || c[k];
  return {
    ...c, subtype: c.subtype || o.subtype,
    ...Object.fromEntries(["siret", "siren", "raison_sociale", "forme_juridique", "naf", "date_creation", "siege_adresse", "etat", "rcs_ville", "capital"].map((k) => [k, pick(k)])),
    procedure: o.procedure ?? c.procedure, vat_number: c.vat_number || o.vat_number,
    representant: { ...rep, ...Object.fromEntries(Object.entries(o.representant || {}).filter(([k, v]) => v && !rep[k] && k !== "signataire_is_rep")) },
  };
};

export const CompanyDocOcr = ({ value, onChange, tid, onPieceAdded }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const run = async (file) => {
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("files", file);
      const { data } = await api.post("/ai/extract-company-doc", fd);
      onChange(merge(value || {}, data.company));
      const label = data.doc_kind === "statuts" ? "Statuts" : data.doc_kind === "kbis" ? "Kbis" : "Document";
      toast.success(`${label} lu : ${data.company.raison_sociale}${data.sirene ? " (vérifié annuaire SIRENE)" : " — non trouvé dans l'annuaire, à vérifier"}`);
      if (tid && ["kbis", "statuts"].includes(data.doc_kind)) {
        const pf = new FormData(); pf.append("file", file); pf.append("kind", data.doc_kind); pf.append("doc_date", data.doc_date || ""); pf.append("expiry_date", "");
        await api.post(`/tenants/${tid}/pieces`, pf);
        toast.success(`${label} classé dans les pièces du locataire`);
        onPieceAdded?.();
      }
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Lecture du document impossible");
    } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-dashed border-brand-limeDark bg-brand-lime/10 p-3" data-testid="co-doc-ocr">
      <ScanLine className="w-5 h-5 text-brand-limeDark shrink-0" />
      <p className="flex-1 text-xs text-brand-green/70"><b className="text-brand-greenDeep">Lire un Kbis ou des statuts (IA)</b> — la fiche se remplit, puis l'identité est vérifiée dans l'annuaire SIRENE.{tid ? " Le document est aussi classé dans les pièces." : ""}</p>
      <input ref={ref} type="file" accept=".pdf,image/*" className="hidden" onChange={(e) => e.target.files[0] && run(e.target.files[0])} data-testid="co-doc-ocr-input" />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-brand-greenDeep text-white text-xs font-semibold disabled:opacity-60" data-testid="co-doc-ocr-btn">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ScanLine className="w-3.5 h-3.5" />} {busy ? "Lecture…" : "Choisir le document"}
      </button>
    </div>
  );
};
